var map = {
	"./19-2.jpeg": 106,
	"./Picture4-300x225x250.png": 107,
	"./Picture4-400x300x150.png": 108,
	"./Picture4-453x300x150.png": 109,
	"./RegenciaAmbiental.png": 110,
	"./RegenciaQuimicaPic.png": 111
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 105;


//////////////////
// WEBPACK FOOTER
// ./src/imagenes ^\.\/.*$
// module id = 105
// module chunks = 0